export default "__VITE_ASSET__BxAYZKHF__"